<nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
  <div class="container">
    <a class="navbar-brand d-flex align-items-center" [routerLink]="'/home'">
      <img src="assets/img/logo.jpeg" alt="Logo" class="rounded-circle" style="height: 50px; width: 50px; margin-right: 10px;">
      <span class="fw-bold text-uppercase" style="font-size: 1.25rem; color: #f8f9fa;">
        HMC IT <span class="text-info">Network Services</span>
      </span>
    </a>

    <!-- Navbar Toggler Button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>


    <!-- Navbar Items -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" [routerLink]="'/home'" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/about'" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/service'" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Our Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/pricing'" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Plans & Pricing</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/contact'" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Contact Us</a>
        </li>
      </ul>

      <a [routerLink]="'/contact'" class="btn btn-outline-light ms-3">Get in Touch</a>
      <span id="navbarClock" class="ms-4 text-light" style="font-size: 1rem;"></span>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>
<!-- Footer -->
<app-footer></app-footer>

